// Location: src/styles/headerStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Styles for header components

import { makeStyles, tokens } from '@fluentui/react-components';

export const useHeaderStyles = makeStyles({
  headerTop: {
    flex: 'auto',
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground2,
    padding: tokens.spacingXXS,
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'flex',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
    },
  },
  headerMain: {
    backgroundColor: tokens.colorNeutralBackground1,
    padding: tokens.spacingM,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  headerColumnLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerButton: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit',
  },
  headerText: {
    marginLeft: tokens.spacingXS,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightBold,
  },
  headerColumnRight: {
    display: 'flex',
    gap: tokens.spacingXS,
  },
  headerBottom: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground2,
    height: '3em',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
});